var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74686 22.9166H2.42751V9.00742H6.74686V22.9166ZM4.58458 7.1101C3.20358 7.1101 2.08301 5.96575 2.08301 4.5848C2.08301 3.92137 2.34657 3.2851 2.8157 2.81598C3.28484 2.34686 3.92113 2.08331 4.58458 2.08331C5.24804 2.08331 5.88433 2.34686 6.35347 2.81598C6.8226 3.2851 7.08616 3.92137 7.08616 4.5848C7.08616 5.96575 5.96559 7.1101 4.58458 7.1101ZM22.9126 22.9166H18.6029V16.1458C18.6029 14.532 18.5702 12.4628 16.3573 12.4628C14.1117 12.4628 13.7672 14.2158 13.7672 16.0297V22.9166H9.45232V9.00742H13.5946V10.9047H13.6548C14.2315 9.81174 15.64 8.65846 17.7413 8.65846C22.1127 8.65846 22.9163 11.5372 22.9163 15.276V22.9166H22.9126Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2bc755a14a2cdffb52b9d63adf4f8e79.svg";
export { ForwardRef as ReactComponent };